module.exports = {
	"name": "voonto",
	"version": "1.1.12",
	"description": "",
	"main": "./src/index.js",
	"scripts": {
		"test": "./node_modules/.bin/mocha-phantomjs dist/spec.html --reporter xunit --file test-results.xml",
		"start": "webpack-dev-server --content-base dist/",
		"build": "./node_modules/.bin/webpack"
	},
	"author": "Iván Pérez <ivanperez@vocento.com>",
	"license": "SEE LICENSE IN LICENSE.md",
	"devDependencies": {
		"babel-core": "^6.17.0",
		"babel-loader": "^6.2.5",
		"babel-polyfill": "^6.16.0",
		"babel-preset-es2015": "^6.16.0",
		"chai": "^3.5.0",
		"html-webpack-plugin": "^2.28.0",
		"json-loader": "^0.5.4",
		"mocha": "^3.1.0",
		"mocha-loader": "^1.0.0",
		"mocha-phantomjs": "^4.1.0",
		"webpack": "^1.13.3",
		"webpack-shell-plugin": "^0.4.3"
	},
	"dependencies": {
		"is_js": "^0.9.0",
		"jquery": "^3.1.1",
		"jquery-inview": "^1.1.2",
		"jquery-lazyload": "^1.9.7",
		"js-cookie": "^2.1.4",
		"lodash": "^4.16.4",
		"moment": "^2.18.1",
		"parse-url": "^1.3.7",
		"react": "^15.5.4",
		"react-dom": "^15.5.4",
		"react-lite": "^0.15.34",
		"rsvp": "^3.5.0",
		"vanilla-lazyload": "^8.0.3"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 55
// module chunks = 0 2 5